import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import { ShireSchoolsSection } from '../components/shared/ShireSchoolsSection';
import { EarlyChildhoodSection } from '../components/shared/EarlyChildhoodSection';

export const Route = createFileRoute('/shire/$name_/schools')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Schools',
      'Schools, TAFE and early childhood / childcare options in this shire.',
    ),
  component: SchoolsPage,
});

function SchoolsPage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Schools"
      title="Schools & early childhood"
      lede={`Public and private schools, TAFE and early childhood care in the Shire of ${shire.name}.`}
    >
      <ShireSchoolsSection shireId={shire.id} />
      <EarlyChildhoodSection shireId={shire.id} />
    </ShireSubPageShell>
  );
}
